import { createContext, useContext } from 'react';
import { DEFAULT_PRESET, type LayoutPreset } from '../../lib/layout';

export interface PresetCtx {
  /** 当前高度档位 */
  preset: LayoutPreset;
  /** 双击图表区 → 轮换到下一个档位 */
  onCyclePreset: () => void;
  isMobile: boolean;
}

/**
 * 高度档位的 context。
 *
 * ⚠️ 单独成文件而非放在 AppShell 里：ChartZone 需要读档位，若从 AppShell
 * 导入就形成 App.tsx → ChartZone → AppShell 的**循环依赖**，在 ESM 下会
 * 表现为「某个模块没有导出 X」这种与真实原因无关的报错（实测报在 NotePanel 上，
 * 因为它恰好是环上第一个未完成初始化的模块）。
 */
const PresetContext = createContext<PresetCtx | null>(null);

export const PresetProvider = PresetContext.Provider;

/** 无 Provider 时（单测、Storybook）回落到默认值而不是抛错 */
export function useLayoutPreset(): PresetCtx {
  return (
    useContext(PresetContext) ?? {
      preset: DEFAULT_PRESET,
      onCyclePreset: () => {},
      isMobile: false,
    }
  );
}